module.exports = __webpack_public_path__ + "91f56e2b6d7137fe47fa699d22350d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home-slide-2.jpg
// module id = 265
// module chunks = 0